import React from 'react';
import { APP_ENV } from 'appenv';
import Landing608Template from './templates/Landing608Template';
import Landing618Template from './templates/Landing618Template';

const LandingTemplateSwitch = () => {
  switch (APP_ENV) {
    case 'polyu618_staging':
    case 'polyu618_production':
      return <Landing618Template />;
    case 'hkstp608_staging':
    case 'hkstp608_production':
    default:
      return <Landing608Template />;
  }
};

export default LandingTemplateSwitch;
